import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../components/HomePage.vue'
import LoginForm from '../components/LoginForm.vue'
import RegisterForm from '../components/RegisterForm.vue'
import RegisterSuccessPage from '../components/RegisterSuccessPage.vue'
import EmailConfirmPage from '../components/EmailConfirmPage.vue'
import DashboardPage from '../components/DashboardPage.vue'
import StreamsPage from '../components/StreamsPage.vue'
import StreamFormPage from '../components/streams/StreamFormPage.vue'
import CmakerRunsPage from '../components/cmaker/CmakerRunsPage.vue'
import CmakerRunDetailPage from '../components/cmaker/CmakerRunDetailPage.vue'
import StreamsContent from '../components/StreamsContent.vue'
import GeneratePage from '../components/content/GeneratePage.vue'
import ContentEditPage from '../components/content/ContentEditPage.vue'
import ProfilePage from '../components/ProfilePage.vue'
import ProfilePasswordPage from '../components/profile/ProfilePasswordPage.vue'
import ProfileCredentialsPage from '../components/profile/ProfileCredentialsPage.vue'
import ToolsPage from '../components/ToolsPage.vue'
import WordPressDeploymentPage from '../components/tools/WordPressDeploymentPage.vue'
import WordPressConceptWizardPage from '../components/tools/WordPressConceptWizardPage.vue'
import FaqPage from '../components/FaqPage.vue'
import AdminNoAccessPage from '@/admin/pages/AdminNoAccessPage.vue'
import { adminRoutes } from '@/admin/routes'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: { title: null },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginForm,
    meta: { guestOnly: true, title: 'Вход' },
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterForm,
    meta: { guestOnly: true, title: 'Регистрация' },
  },
  {
    path: '/register/success',
    name: 'RegisterSuccess',
    component: RegisterSuccessPage,
    meta: { guestOnly: true, title: 'Регистрация завершена' },
  },
  {
    path: '/confirm-email',
    name: 'EmailConfirm',
    component: EmailConfirmPage,
    meta: { title: 'Подтверждение email' },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardPage,
    meta: { requiresAuth: true, title: 'Дашборд' },
  },
  {
    path: '/streams',
    name: 'Streams',
    component: StreamsPage,
    meta: { requiresAuth: true, title: 'Потоки' },
  },
  {
    path: '/streams/new',
    name: 'StreamCreate',
    component: StreamFormPage,
    meta: { requiresAuth: true, title: 'Новый поток' },
  },
  {
    path: '/streams/:id/edit',
    name: 'StreamEdit',
    component: StreamFormPage,
    meta: { requiresAuth: true, title: 'Редактирование потока' },
  },
  {
    // Same unified editor as /edit; opens the "Автоматическая генерация" tab.
    path: '/streams/:id/schedule',
    name: 'StreamSchedule',
    component: StreamFormPage,
    meta: { requiresAuth: true, title: 'Расписание потока' },
  },
  {
    path: '/streams/:id/content',
    name: 'StreamsContent',
    component: StreamsContent,
    meta: { requiresAuth: true, title: 'Контент потока' },
  },
  {
    path: '/cmaker/runs',
    name: 'CmakerRuns',
    component: CmakerRunsPage,
    meta: { requiresAuth: true, title: 'Запуски Cmaker' },
  },
  {
    path: '/cmaker/runs/:jobId',
    name: 'CmakerRunDetail',
    component: CmakerRunDetailPage,
    meta: { requiresAuth: true, title: 'Запуск Cmaker' },
  },
  {
    path: '/streams/:streamId/content/:contentId/generate',
    name: 'GenerateContent',
    component: GeneratePage,
    meta: { requiresAuth: true, title: 'Генерация контента' },
  },
  {
    path: '/streams/:streamId/content/:contentId/edit',
    name: 'EditContent',
    component: ContentEditPage,
    meta: { requiresAuth: true, title: 'Редактирование контента' },
  },
  {
    path: '/profile',
    alias: '/lk',
    name: 'Profile',
    component: ProfilePage,
    meta: { requiresAuth: true, title: 'Профиль' },
  },
  {
    path: '/profile/password',
    name: 'ProfilePassword',
    component: ProfilePasswordPage,
    meta: { requiresAuth: true, title: 'Смена пароля' },
  },
  {
    path: '/profile/credentials',
    name: 'ProfileCredentials',
    component: ProfileCredentialsPage,
    meta: { requiresAuth: true, title: 'Учётные данные' },
  },
  {
    path: '/tools',
    alias: '/settings',
    name: 'Tools',
    component: ToolsPage,
    meta: { requiresAuth: true, title: 'Инструменты' },
  },
  {
    path: '/faq',
    name: 'Faq',
    component: FaqPage,
    meta: { requiresAuth: true, title: 'FAQ' },
  },
  {
    path: '/tools/wordpress-deployment/:deploymentId?',
    name: 'WordPressDeployment',
    component: WordPressDeploymentPage,
    meta: { requiresAuth: true, title: 'Развёртывание WordPress' },
  },
  {
    path: '/tools/wordpress-concept',
    name: 'WordPressConceptProjects',
    component: WordPressConceptWizardPage,
    meta: { requiresAuth: true, title: 'WordPress: концепции' },
  },
  {
    path: '/tools/wordpress-concept/new',
    name: 'WordPressConceptWizardNew',
    component: WordPressConceptWizardPage,
    meta: { requiresAuth: true, title: 'WordPress: новая концепция' },
  },
  {
    path: '/tools/wordpress-concept/:projectId',
    name: 'WordPressConceptWizard',
    component: WordPressConceptWizardPage,
    meta: { requiresAuth: true, title: 'WordPress: концепция' },
  },
  {
    path: '/no-access',
    name: 'NoAccess',
    component: AdminNoAccessPage,
    meta: { requiresAuth: true, title: 'Нет доступа' },
  },
  ...adminRoutes,
]

const BRAND = 'STREAM-MEDIA'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.afterEach((to) => {
  const pageTitle = to.meta.title
  document.title = pageTitle ? `${BRAND} — ${pageTitle}` : BRAND
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
    next({ name: 'Login' })
  } else if (to.meta.requiresAdmin && !store.getters.isAdmin) {
    next({ name: 'NoAccess' })
  } else if (to.meta.guestOnly && store.getters.isAuthenticated) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

export default router
